/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntranetPortal_Occasions_Dtos_AllBirthdayMessageListForTodayDto } from '../models/IntranetPortal_Occasions_Dtos_AllBirthdayMessageListForTodayDto';
import type { IntranetPortal_Occasions_Dtos_AllOccassionMessageListForTodayDto } from '../models/IntranetPortal_Occasions_Dtos_AllOccassionMessageListForTodayDto';
import type { IntranetPortal_Occasions_Dtos_AllWorkAnniversaryMessageListForTodayDto } from '../models/IntranetPortal_Occasions_Dtos_AllWorkAnniversaryMessageListForTodayDto';
import type { IntranetPortal_Occasions_Dtos_EmployeeListForWorkAnniversaryDto } from '../models/IntranetPortal_Occasions_Dtos_EmployeeListForWorkAnniversaryDto';
import type { IntranetPortal_Occasions_Dtos_EmployeesListForBirthdayTodayDto } from '../models/IntranetPortal_Occasions_Dtos_EmployeesListForBirthdayTodayDto';
import type { IntranetPortal_Occasions_Dtos_GreetingResponseSentToMeDto } from '../models/IntranetPortal_Occasions_Dtos_GreetingResponseSentToMeDto';
import type { IntranetPortal_Occasions_Dtos_MessageListForMyBirthdayDto } from '../models/IntranetPortal_Occasions_Dtos_MessageListForMyBirthdayDto';
import type { IntranetPortal_Occasions_Dtos_MessageListForMyWorkAnniversaryDto } from '../models/IntranetPortal_Occasions_Dtos_MessageListForMyWorkAnniversaryDto';
import type { IntranetPortal_Occasions_Dtos_MyWorkAnniversaryTodayDto } from '../models/IntranetPortal_Occasions_Dtos_MyWorkAnniversaryTodayDto';
import type { IntranetPortal_Occasions_Dtos_RespondOccasionGreetingDto } from '../models/IntranetPortal_Occasions_Dtos_RespondOccasionGreetingDto';
import type { IntranetPortal_Occasions_Dtos_RespondToOccasionGreetingInputDto } from '../models/IntranetPortal_Occasions_Dtos_RespondToOccasionGreetingInputDto';
import type { IntranetPortal_Occasions_Dtos_WishBirthdayDto } from '../models/IntranetPortal_Occasions_Dtos_WishBirthdayDto';
import type { IntranetPortal_Occasions_Dtos_WishBirthdayInputDto } from '../models/IntranetPortal_Occasions_Dtos_WishBirthdayInputDto';
import type { IntranetPortal_Occasions_Dtos_WishWorkAnniversaryDto } from '../models/IntranetPortal_Occasions_Dtos_WishWorkAnniversaryDto';
import type { IntranetPortal_Occasions_Dtos_WishWorkAnniversaryInputDto } from '../models/IntranetPortal_Occasions_Dtos_WishWorkAnniversaryInputDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OccasionService {

    /**
     * @returns IntranetPortal_Occasions_Dtos_EmployeeListForWorkAnniversaryDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppOccasionEmployeeListForWorkAnniversaryToday(): CancelablePromise<Array<IntranetPortal_Occasions_Dtos_EmployeeListForWorkAnniversaryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/occasion/employee-list-for-work-anniversary-today',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @returns IntranetPortal_Occasions_Dtos_MyWorkAnniversaryTodayDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppOccasionMyWorkAnniversaryToday(): CancelablePromise<IntranetPortal_Occasions_Dtos_MyWorkAnniversaryTodayDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/occasion/my-work-anniversary-today',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @returns IntranetPortal_Occasions_Dtos_EmployeesListForBirthdayTodayDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppOccasionEmployeesListForBirthdayToday(): CancelablePromise<Array<IntranetPortal_Occasions_Dtos_EmployeesListForBirthdayTodayDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/occasion/employees-list-for-birthday-today',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @returns IntranetPortal_Occasions_Dtos_EmployeesListForBirthdayTodayDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppOccasionMyBirthdayToday(): CancelablePromise<IntranetPortal_Occasions_Dtos_EmployeesListForBirthdayTodayDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/occasion/my-birthday-today',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns IntranetPortal_Occasions_Dtos_WishBirthdayDto Success
     * @throws ApiError
     */
    public static postCoreApiApiAppOccasionWishBirthday(
        requestBody?: IntranetPortal_Occasions_Dtos_WishBirthdayInputDto,
    ): CancelablePromise<IntranetPortal_Occasions_Dtos_WishBirthdayDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/core-api/api/app/occasion/wish-birthday',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns IntranetPortal_Occasions_Dtos_WishWorkAnniversaryDto Success
     * @throws ApiError
     */
    public static postCoreApiApiAppOccasionWishWorkAnniversary(
        requestBody?: IntranetPortal_Occasions_Dtos_WishWorkAnniversaryInputDto,
    ): CancelablePromise<IntranetPortal_Occasions_Dtos_WishWorkAnniversaryDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/core-api/api/app/occasion/wish-work-anniversary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @param occasionId
     * @returns IntranetPortal_Occasions_Dtos_MessageListForMyWorkAnniversaryDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppOccasionMessageListForMyWorkAnniversary(
        occasionId?: string,
    ): CancelablePromise<Array<IntranetPortal_Occasions_Dtos_MessageListForMyWorkAnniversaryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/occasion/message-list-for-my-work-anniversary',
            query: {
                'OccasionId': occasionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @param occasionId
     * @returns IntranetPortal_Occasions_Dtos_MessageListForMyBirthdayDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppOccasionMessageListForMyBirthday(
        occasionId?: string,
    ): CancelablePromise<Array<IntranetPortal_Occasions_Dtos_MessageListForMyBirthdayDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/occasion/message-list-for-my-birthday',
            query: {
                'OccasionId': occasionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @returns IntranetPortal_Occasions_Dtos_AllBirthdayMessageListForTodayDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppOccasionBirthdayMessageListSentByMeToday(): CancelablePromise<Array<IntranetPortal_Occasions_Dtos_AllBirthdayMessageListForTodayDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/occasion/birthday-message-list-sent-by-me-today',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @returns IntranetPortal_Occasions_Dtos_AllWorkAnniversaryMessageListForTodayDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppOccasionWorkAnniversaryMessageListSentByMeToday(): CancelablePromise<Array<IntranetPortal_Occasions_Dtos_AllWorkAnniversaryMessageListForTodayDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/occasion/work-anniversary-message-list-sent-by-me-today',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns IntranetPortal_Occasions_Dtos_RespondOccasionGreetingDto Success
     * @throws ApiError
     */
    public static postCoreApiApiAppOccasionRespondToOccasionGreeting(
        requestBody?: IntranetPortal_Occasions_Dtos_RespondToOccasionGreetingInputDto,
    ): CancelablePromise<IntranetPortal_Occasions_Dtos_RespondOccasionGreetingDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/core-api/api/app/occasion/respond-to-occasion-greeting',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @returns IntranetPortal_Occasions_Dtos_GreetingResponseSentToMeDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppOccasionGreetingResponseSentToMe(): CancelablePromise<Array<IntranetPortal_Occasions_Dtos_GreetingResponseSentToMeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/occasion/greeting-response-sent-to-me',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @returns IntranetPortal_Occasions_Dtos_AllOccassionMessageListForTodayDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppOccasionOcassionResponseMessageListSentByMeToday(): CancelablePromise<Array<IntranetPortal_Occasions_Dtos_AllOccassionMessageListForTodayDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/occasion/ocassion-response-message-list-sent-by-me-today',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns IntranetPortal_Occasions_Dtos_RespondOccasionGreetingDto Success
     * @throws ApiError
     */
    public static postCoreApiApiAppOccasionRespondToOccasionGreetings(
        requestBody?: IntranetPortal_Occasions_Dtos_RespondToOccasionGreetingInputDto,
    ): CancelablePromise<IntranetPortal_Occasions_Dtos_RespondOccasionGreetingDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/core-api/api/app/occasion/respond-to-occasion-greetings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @param occasionIds
     * @returns IntranetPortal_Occasions_Dtos_AllOccassionMessageListForTodayDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppOccasionOcassionResponseMessageListSentByMe(
        occasionIds?: Array<string>,
    ): CancelablePromise<Array<IntranetPortal_Occasions_Dtos_AllOccassionMessageListForTodayDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/occasion/ocassion-response-message-list-sent-by-me',
            query: {
                'occasionIds': occasionIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @param occasionIds
     * @returns IntranetPortal_Occasions_Dtos_GreetingResponseSentToMeDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppOccasionGreetingsResponseSentToMe(
        occasionIds?: Array<string>,
    ): CancelablePromise<Array<IntranetPortal_Occasions_Dtos_GreetingResponseSentToMeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/occasion/greetings-response-sent-to-me',
            query: {
                'occasionIds': occasionIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

}
